export default {"src":"https://cp-landing.wukongedu.net/_next/static/media/logo.f5246c1e.svg","height":273,"width":815,"blurWidth":0,"blurHeight":0};